import { apiClient } from '_app'
import { ApiResponse } from 'dtos'
import { InspectionCompanyInformationDto } from 'dtos/companies'

const baseUrl = (companyGuid: string): string => `/api/companies/${encodeURIComponent(companyGuid)}/inspection-company`

export const getInspectionCompanyInformation = (companyGuid: string) =>
  apiClient.get<ApiResponse<InspectionCompanyInformationDto>>(baseUrl(companyGuid)).then(res => res.data)

export const updateInspectionCompanyInformation = (companyGuid: string, data: InspectionCompanyInformationDto) =>
  apiClient.put<ApiResponse<InspectionCompanyInformationDto>>(baseUrl(companyGuid), data).then(res => res.data)
